import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController } from 'ionic-angular';


@IonicPage()
@Component({
  selector: 'page-cargos-editar',
  templateUrl: 'cargos-editar.html',
})
export class CargosEditarPage {
  cargo:any[] = []
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public viewControllers:ViewController) {
    if(this.navParams.get('cargo')){
      this.cargo = this.navParams.get('cargo')
    }
  }

  ionViewDidLoad() {}

  dismiss(){
    this.viewControllers.dismiss();
  }

  submit(){
   this.viewControllers.dismiss(this.cargo);
  }

}



// WEBPACK FOOTER //
// ./src/pages/cargos/cargos-editar/cargos-editar.ts